import { Box, Skeleton, Stack } from '@mui/material';

export default function QATabLoading() {
  return (
    <Box border='1px solid #ECECEC' borderRadius={3} p={2.5} bgcolor='#fff'>
      <Stack spacing={2}>
        {/* Top row */}
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          <Stack direction='row' alignItems='center' gap={1} px={1.2} py={0.5} borderRadius='12px'>
            <Skeleton variant='circular' width={6} height={6} />
            <Skeleton variant='text' width={200} height={18} />
          </Stack>

          <Stack direction='row' alignItems='center' gap={0.5}>
            <Skeleton variant='circular' width={16} height={16} />
            <Skeleton variant='text' width={60} height={16} />
          </Stack>
        </Stack>

        {/* Question + Description */}
        <Box borderBottom='1px solid #ECECEC' pb={1.5}>
          <Skeleton variant='text' width='60%' height={24} />
          <Skeleton variant='text' width='90%' height={18} />
          <Skeleton variant='text' width='80%' height={18} />
        </Box>

        {/* Footer */}
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          {/* Call IDs */}
          <Stack direction='row' spacing={1}>
            <Skeleton variant='rounded' width={60} height={24} />
            <Skeleton variant='rounded' width={60} height={24} />
            <Skeleton variant='rounded' width={60} height={24} />
          </Stack>

          {/* Buttons */}
          <Stack direction='row' spacing={1.5}>
            <Skeleton variant='rounded' width={80} height={36} />
            <Skeleton variant='rounded' width={110} height={36} />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}
